export class FilterSPoData {
    public  company_code?: string;
    public  plant?: string;
    public doc_type?: string;
    public doc_cat?: string;
    public poagreement_no?: string;
    public  vendor_code?: string;
    public  document_date?: Date;
    [key: string]: string | Date | undefined;
  }
export class FilterAsnData{
  public  name?: string;
  public  status?: string;
  public deliver_from?: string;
  public deliver_to?: string;
}
